import { render, staticRenderFns } from "./DeskTagsFilter.vue?vue&type=template&id=0fdde786&scoped=true&"
import script from "./DeskTagsFilter.vue?vue&type=script&lang=js&"
export * from "./DeskTagsFilter.vue?vue&type=script&lang=js&"
import style0 from "./DeskTagsFilter.vue?vue&type=style&index=0&id=0fdde786&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdde786",
  null
  
)

export default component.exports